<template>
  <div class="content">
    <div class="title" style="margin-bottom: 35px">
      学籍异动表申请【{{ info.dict.type }}】
    </div>
    <div class="title" style="margin-bottom: 27px">学籍信息</div>
    <div class="mesaage">
      <img src="./imagas/changeState/icon_3.png" />
      <div class="text">学校</div>
      <div>{{ user.eduName }}</div>
    </div>
    <div class="mesaage">
      <img src="./imagas/changeState/icon_4.png" />
      <div class="text">姓名</div>
      <div>{{ user.name }}</div>
    </div>
    <div class="mesaage">
      <img src="./imagas/changeState/icon_5.png" />
      <div class="text">年级</div>
      <div>{{ user.grade }}</div>
    </div>
    <div class="mesaage">
      <img src="./imagas/changeState/icon_6.png" />
      <div class="text">层次</div>
      <div>{{ user.learnLevel }}</div>
    </div>
    <div class="mesaage">
      <img src="./imagas/changeState/icon_7.png" />
      <div class="text">专业</div>
      <div>{{ user.proName }}</div>
    </div>
    <div class="mesaage">
      <img src="./imagas/changeState/icon_8.png" />
      <div class="text">教学点</div>
      <div>{{ user.siteName }}</div>
    </div>
    <a-divider dashed style="margin: 30px 0" />
    <div v-if="info.docList && info.docList.length > 0">
      <div class="title" style="margin-bottom: 27px">附件列表</div>
      <div class="attachment_out">
        <div
          v-for="item in info.docList"
          :key="item.id"
          @click="onAttachment(item.docUrl)"
        >
          <img src="./imagas/changeState/doc.png" v-if="item.type == 'doc'" />
          <img src="./imagas/changeState/pdf.png" v-if="item.type == 'pdf'" />
          <img
            src="./imagas/changeState/excel.png"
            v-if="item.type == 'excel'"
          />
          <img src="./imagas/changeState/jpg.png" v-if="item.type == 'jpg'" />
          <img src="./imagas/changeState/zip.png" v-if="item.type == 'zip'" />
          <img src="./imagas/changeState/txt.png" v-if="item.type == 'txt'" />
          {{ item.docName }}
        </div>
      </div>
      <a-divider dashed style="margin: 30px 0" />
    </div>
    <div class="from_out" v-if="itemList.length > 0">
      <div class="left">
        转入{{ info.type == 0 ? "专业" : info.type == 1 ? "教学点" : "年级" }}
      </div>
      <a-select
        show-search
        :placeholder="
          '请选择' +
          (info.type == 0 ? '专业' : info.type == 1 ? '教学点' : '年级')
        "
        v-model="subMessage.applyCode"
        option-filter-prop="children"
        style="width: 200px"
        :filter-option="filterOption"
        class="right"
      >
        <a-select-option
          :value="item.value"
          v-for="item in itemList"
          :key="item.value"
        >
          {{ item.text }}
        </a-select-option>
      </a-select>
    </div>
    <div class="from_out">
      <div class="left">申请理由</div>
      <a-textarea
        class="right"
        v-model="subMessage.applyRemark"
        placeholder="请简单描述一下申请理由，不少于10个字符"
        :auto-size="{ minRows: 3, maxRows: 5 }"
      />
    </div>
    <div v-if="info.configs && info.configs.length" class="info-item">
      <docListUpload
        required
        v-for="item in info.configs"
        :key="item.id"
        :info="item"
        :ref="item.id"
        :id="id"
        @change="onFileChange"
        @remove="onFileRemove"
        style="margin-bottom: 30px"
      ></docListUpload>
    </div>
    <a-divider dashed style="margin: 30px 0" />
    <div class="footer">
      <div @click="sub(4)">暂存</div>
      <div class="sub" @click="sub(0)">提交申请</div>
      <div @click="cancel">取消申请</div>
    </div>
  </div>
</template>
<script>
import { checkFileType } from "../../../utils/util";
import docListUpload from "./docListUploadV2.vue";
export default {
  name: "ChangeDetail",
  components: {
    docListUpload,
  },
  props: {
    id: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      value: "",
      subMessage: {
        applyCode: "",
        applyName: "",
        applyRemark: "",
      },
      user: null,
      info: null,
      itemList: [],
      fileList: [],
    };
  },
  mounted() {
    this.getInfo();
    this.getUser();
    this.getItem();
  },
  methods: {
    async getInfo() {
      let res = await this.axios.get(`/biz/archive/apply/timeInfo`, {
        params: { timeId: this.id },
      });
      const { result } = res;
      if (result.docList) {
        result.docList.map((res) => {
          res.type = checkFileType(res.docUrl);
        });
      }
      if (result.stashId) {
        let storage = await this.axios.get(`/biz/archive/apply/info`, {
          params: { applyId: result.stashId },
        });
        const { result: storageResult } = storage;
        this.subMessage.applyRemark = storageResult.applyRemark;
        this.subMessage.applyCode = storageResult.applyCode;
        if (storageResult.documentsList.length > 0) {
          storageResult.documentsList.map((res) => {
            result.configs.map((key) => {
              if (res.configId == key.id) {
                if (!key.fileList) {
                  key.fileList = [];
                }
                key.fileList.push(res);
              }
            });
          });
        }
      }
      this.info = result;
    },
    async getUser() {
      let res = await this.axios.get(`/biz/archive/info`);
      this.user = res.result;
    },
    async getItem() {
      let res = await this.axios.get(`/biz/archive/canApplyItem`, {
        params: { timeId: this.id },
      });
      this.itemList = res.result;
    },
    onAttachment(url) {
      window.open(url, "_blank");
    },
    onFileChange({ file, configId }) {
      this.fileList.push({
        uid: file.uid,
        docUrl: file.url,
        docName: file.name,
        fileSize: file.size,
        configId,
      });
    },
    onFileRemove({ id, uid }) {
      const index = this.fileList.findIndex((item) => item.uid === uid);
      this.fileList.splice(index, 1);
      if (id) this.delFileIds.push(id);
    },
    cancel() {
      this.$emit("close");
    },
    async sub(type) {
      if (type == 0) {
        if (this.info.type == 0 || this.info.type == 1 || this.info.type == 2) {
          if (!this.subMessage.applyCode) {
            this.$message.warning(
              `请选择${
                this.info.type == 0
                  ? "专业"
                  : this.info.type == 1
                  ? "教学点"
                  : "年级"
              }`
            );
            return;
          }
        }
        if (
          !this.subMessage.applyRemark ||
          this.subMessage.applyRemark.length < 10
        ) {
          this.$message.warning("请输入正确的申请理由");
          return;
        }
        if (this.info.configs) {
          for (const res of this.info.configs) {
            if (res.isRequire) {
              const index = this.fileList.findIndex(
                (item) => item.configId === res.id
              );
              if (index < 0) {
                this.$message.warning(`请上传${res.fileTitle}`);
                return; // 直接跳出整个函数
              }
            }
          }
        }
      }
      if (this.subMessage.applyCode) {
        this.itemList.map((res) => {
          if (res.value == this.subMessage.applyCode) {
            this.subMessage.applyName = res.title;
          }
        });
      }
      const params = {
        ...this.subMessage,
        documentsList: this.fileList,
        applyTimeId: this.id,
        state: type,
        id: this.info.stashId,
      };
      let res = await await this.axios.post(`/biz/archive/apply/add`, params);
      if (res.code == 200) {
        this.$message.success(`${type == 4 ? "暂存" : "申请"}成功`);
        this.$emit("close", 1);
      } else {
        this.$message.error(res.message);
      }
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
  },
};
</script>
<style lang="stylus" scoped>
@import '~styles/varibles.styl';
@import '~styles/mixins.styl';

.content {
  background: #fff;
  padding: 28px;

  .title {
    font-family: MicrosoftYaHei, MicrosoftYaHei;
    font-weight: bold;
    font-size: 16px;
    color: #333333;
    line-height: 30px;
    display: flex;
    align-items: center;

    span {
      font-size: 14px;
      color: #999999;
      font-weight: 400;
      margin-left: 10px;
    }
  }

  .attachment_out {
    display: flex;
    flex-wrap: wrap;

    div {
      img {
        width: 18px;
        margin-right: 10px;
      }

      font-family: PingFang-SC, PingFang-SC;
      font-weight: 400;
      font-size: 14px;
      color: #333333;
      line-height: 18px;
      cursor: pointer;
      margin-right: 30px;
      margin-bottom: 10px;
      display: flex;
      align-items: center;
      text-decoration: underline;
    }
  }

  .mesaage {
    display: flex;
    align-items: center;
    font-family: MicrosoftYaHei;
    font-size: 14px;
    color: #303133;
    line-height: 38px;

    .text {
      margin-left: 8px;
      margin-right: 30px;
      color: #999999;
      width: 45px;
      text-align-last: justify;
    }

    img {
      width: 16px;
      height: 16px;
    }
  }

  .from_out {
    display: flex;
    margin-bottom: 30px;

    .left {
      width: 70px;
      text-align: right;
      font-family: MicrosoftYaHei;
      font-size: 14px;
      color: #000000;
      line-height: 36px;
      margin-right: 20px;
    }

    .right {
      flex: 1;
    }
  }

  .footer {
    padding: 35px 0;
    display: flex;
    justify-content: center;

    div {
      width: 120px;
      height: 36px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-family: MicrosoftYaHei;
      font-size: 14px;
      color: #333333;
      border-radius: 4px;
      border: 1px solid #d1d4d2;
      cursor: pointer;
    }

    .sub {
      margin: 0 30px;
      background: $bgColor;
      color: #fff;
      border: none;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/PersonalCenters/components/changeDetail.vue